module.exports = __webpack_public_path__ + "img/oranjeplein_A5_v2.6b72e55c.jpg";